import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { Paragraph } from 'src/interviews/components/Layout/Embedded';

type Props = {
  label: string;
  variant: 'check' | 'close' | 'graycheck';
};

function Pill(props: Props) {
  const { label, variant } = props;

  return (
    <span
      className={`
        bp-flex 
        bp-items-start 
        bp-gap-1 
        bp-rounded-[20px] 
        bp-px-[10px] 
        bp-py-[5px]
        ${variant === 'check' ? 'bp-bg-blue-10' : variant === 'graycheck' ? 'bp-bg-gray-20' : 'bp-bg-gray-10'} 
      `}
    >
      {variant.includes('check') ? (
        <CheckIcon
          fontSize="small"
          className={`bp-min-h-4 !bp-text-xs ${variant === 'graycheck' ? 'bp-text-gray-70' : 'bp-text-gray-100'}`}
        />
      ) : (
        <CloseIcon
          fontSize="small"
          className={`bp-min-h-4 !bp-text-xs ${variant === 'graycheck' ? 'bp-text-gray-70' : 'bp-text-gray-100'}`}
        />
      )}
      <Paragraph
        className={`!bp-text-xs ${variant === 'graycheck' ? 'bp-text-gray-70' : 'bp-text-gray-100'}`}
      >
        {label}
      </Paragraph>
    </span>
  );
}

export default Pill;
